<ion-header>
  <ion-toolbar>
    <ion-title class="song-modal-title">{{ song.title }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()" aria-label="Close">
        <ion-icon name="close-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-segment [(ngModel)]="activeSegment" (ionChange)="onSegmentChange($event)" mode="md">
      <ion-segment-button value="notes">
        <ion-icon name="document-text-outline"></ion-icon>
        <ion-label>{{ 'PLAYLISTS.SONG_NOTES' | translate }}</ion-label>
      </ion-segment-button>
      <ion-segment-button value="lyrics">
        <ion-icon name="musical-notes-outline"></ion-icon>
        <ion-label>{{ 'PLAYLISTS.LYRICS' | translate }}</ion-label>
      </ion-segment-button>
      <ion-segment-button value="comments">
        <ion-icon name="chatbubble-outline"></ion-icon>
        <ion-label>{{ 'PLAYLISTS.COMMENTS' | translate }}</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>

<!-- ion-content scroll is managed per-tab: lyrics handles its own scroll -->
<ion-content [scrollY]="activeSegment !== 'lyrics'">

  <!-- ── Notes tab ─────────────────────────────────────────────────────── -->
  <div *ngIf="activeSegment === 'notes'"
       class="notes-content markdown-content"
       [innerHTML]="renderedNote">
  </div>

  <!-- ── Lyrics tab ────────────────────────────────────────────────────── -->
  <div *ngIf="activeSegment === 'lyrics'" class="lyrics-content">

    <!-- YouTube player — only present while Lyrics tab is active -->
    <div class="yt-player-wrapper" [class.yt-hidden]="!hasLyrics">
      <div #ytPlayerContainer class="yt-player-container"></div>
    </div>

    <!-- Loading / auto-fetching -->
    <div *ngIf="lyricsLoading" class="lyrics-loading">
      <ion-spinner name="crescent" color="medium"></ion-spinner>
      <span>{{ 'PLAYLISTS.FETCHING_CAPTIONS' | translate }}</span>
    </div>

    <!-- Error / no captions -->
    <div *ngIf="!lyricsLoading && !hasLyrics" class="no-lyrics">
      {{ lyricsError || ('PLAYLISTS.NO_LYRICS' | translate) }}
    </div>

    <!-- Lyrics list -->
    <ng-container *ngIf="!lyricsLoading && hasLyrics">
      <div class="lyrics-toolbar">
        <ion-button fill="clear" size="small" (click)="toggleTranslations()" [disabled]="translating">
          <ion-spinner *ngIf="translating" name="crescent" slot="start" style="width:16px;height:16px;margin-right:6px;"></ion-spinner>
          <span *ngIf="!translating">
            {{ (translationsVisible ? 'PLAYLISTS.HIDE_TRANSLATIONS' : 'PLAYLISTS.SHOW_TRANSLATIONS') | translate }}
          </span>
          <span *ngIf="translating">{{ 'PLAYLISTS.TRANSLATING' | translate }}</span>
        </ion-button>
      </div>

      <div class="lyrics-scroll">
        <div
          *ngFor="let seg of song.transcriptSegments; let i = index"
          class="lyric-line"
          [class.active]="activeSegmentIndex === i"
          (click)="seekToTime(seg.start)"
          role="button"
          tabindex="0"
          (keydown.enter)="seekToTime(seg.start)">
          <span class="lyric-time">{{ formatTime(seg.start) }}</span>
          <div class="lyric-text-wrapper">
            <span class="lyric-text">{{ seg.text }}</span>
            <span *ngIf="translationsVisible && translations[i]" class="lyric-translation">{{ translations[i] }}</span>
          </div>
        </div>
      </div>
    </ng-container>

  </div>

  <!-- ── Comments tab ──────────────────────────────────────────────────── -->
  <div *ngIf="activeSegment === 'comments'" class="comments-content">

    <div *ngIf="canComment" class="comment-input-wrapper">
      <ion-textarea
        [(ngModel)]="newCommentText"
        [placeholder]="'PLAYLISTS.ADD_COMMENT_PLACEHOLDER' | translate"
        [autoGrow]="true"
        rows="3"
        maxlength="1000"
        class="comment-textarea">
      </ion-textarea>
      <ion-button expand="block" size="small" [disabled]="!newCommentText.trim()" (click)="submitComment()">
        {{ 'PLAYLISTS.POST_COMMENT' | translate }}
      </ion-button>
    </div>
    <p *ngIf="!canComment" class="no-comment-permission">
      {{ 'PLAYLISTS.SIGN_IN_COMMENT_MSG' | translate }}
    </p>

    <div *ngIf="commentsLoading" class="comments-loading">
      <ion-spinner name="crescent" color="medium"></ion-spinner>
    </div>

    <div *ngIf="!commentsLoading && comments.length === 0" class="no-comments">
      {{ 'PLAYLISTS.NO_COMMENTS' | translate }}
    </div>

    <div class="comments-list">
      <div *ngFor="let comment of comments" class="comment-item">
        <div class="comment-header">
          <span class="comment-author">{{ comment.displayName }}</span>
          <span class="comment-date">{{ comment.createdAt.toDate() | date:'MMM d, y' }}</span>
          <div *ngIf="comment.uid === currentUserUid" class="comment-actions">
            <ion-button fill="clear" size="small" (click)="startEditComment(comment)" aria-label="Edit comment">
              <ion-icon name="pencil-outline" slot="icon-only"></ion-icon>
            </ion-button>
            <ion-button fill="clear" size="small" color="danger" (click)="deleteComment(comment)" aria-label="Delete comment">
              <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
            </ion-button>
          </div>
        </div>
        <ng-container *ngIf="editingCommentId === comment.id; else commentView">
          <ion-textarea
            [(ngModel)]="editingCommentText"
            [autoGrow]="true"
            rows="2"
            maxlength="1000"
            class="comment-textarea edit-textarea">
          </ion-textarea>
          <div class="edit-actions">
            <ion-button size="small" (click)="saveEditComment()" [disabled]="!editingCommentText.trim()">
              {{ 'SETTINGS.OK' | translate }}
            </ion-button>
            <ion-button size="small" fill="clear" color="medium" (click)="cancelEditComment()">
              {{ 'SETTINGS.CANCEL' | translate }}
            </ion-button>
          </div>
        </ng-container>
        <ng-template #commentView>
          <p class="comment-text">{{ comment.text }}</p>
        </ng-template>
      </div>
    </div>

  </div>

</ion-content>
